import React, { useMemo, useState } from "react";

import Navbar from '../Navbar';
import Footer from '../Footer';
import Top from '../Top';

const bg = new URL("./bg.png", import.meta.url).href;

const Matches = [
  // { date: "2025-09-25", teamA: "SMA X", scoreA: 12, teamB: "SMA Lorem Ipsum", scoreB: 16 },
  { date: "2025-09-25", teamA: "", scoreA: 0, teamB: "", scoreB: 0}
];

const monthLabel = (iso) => {
  const d = new Date(iso + "T00:00:00");
  const m = d.toLocaleString(undefined, { month: "short" });
  const dd = d.toLocaleString(undefined, { day: "2-digit" });
  return [m, dd];
};

function DatePill({ iso, selected, onSelect }) {
  const [m, dd] = monthLabel(iso);
  return (
    <button
      onClick={() => onSelect(iso)}
      className={`flex h-24 w-28 flex-col items-center justify-center border border-black text-center shadow-sm transition
        ${selected ? "bg-[#14CCCC99]" : "bg-[#14CCCC40] hover:bg-[#14CCCC66]"}`}
      aria-pressed={selected}
    >
      <span className="text-[11px] uppercase tracking-widest text-[#2B387D]">{m}</span>
      <span className="text-5xl font-bold text-[#2B387D] leading-7 pt-2">{dd}</span>
    </button>
  );
}

function MatchCard({ match }) {
  const { teamA, teamB, scoreA, scoreB } = match;
  const aWin = Number.isFinite(scoreA) && Number.isFinite(scoreB) && scoreA > scoreB;
  const bWin = Number.isFinite(scoreA) && Number.isFinite(scoreB) && scoreB > scoreA;

  return (
    <article className="relative mx-auto w-full max-w-5xl overflow-hidden shadow-md ring-1 ring-slate-200 bg-white/95">
      <div className="grid grid-cols-1 items-center gap-6 p-8 sm:grid-cols-[1fr_auto_1fr]">
        {/* Left team + score */}
        <div className="flex items-center gap-6">
          <div className={`text-5xl sm:text-6xl font-extrabold tabular-nums ${aWin ? "text-emerald-600" : "text-slate-900"}`}>
            {Number.isFinite(scoreA) ? scoreA : "–"}
          </div>
          <div className="text-xl sm:text-2xl font-medium text-slate-800 truncate">{teamA}</div>
        </div>

        {/* VS */}
        <div className="flex items-center justify-center">
          <div className="border border-slate-300 bg-white/90 px-5 py-1.5 text-2xl sm:text-3xl font-black tracking-widest text-slate-700">
            VS
          </div>
        </div>

        {/* Right team + score */}
        <div className="flex items-center justify-end gap-6">
          <div className="text-xl sm:text-2xl font-medium text-slate-800 truncate text-right">{teamB}</div>
          <div className={`text-5xl sm:text-6xl font-extrabold tabular-nums ${bWin ? "text-emerald-600" : "text-slate-900"}`}>
            {Number.isFinite(scoreB) ? scoreB : "–"}
          </div>
        </div>
      </div>

    </article>
  );
}

export default function BadminGandaPutraSMA({ matches = Matches, backgroundImageUrl = `${`${bg}`}`, navHeight = 72 }) {
  const dates = useMemo(() => Array.from(new Set(matches.map((m) => m.date))).sort(), [matches]);
  const [selected, setSelected] = useState(dates[0] ?? new Date().toISOString().slice(0, 10));
  const dayMatches = matches.filter((m) => m.date === selected);

  return (
    <div className="min-h-screen w-full bg-[#E9F6FF] flex flex-col">
      <Navbar />

      <div className="mx-auto w-full flex-1" style={{ paddingTop: navHeight + 32 }}>
        <div className="mx-auto max-w-6xl px-4 pb-10">
          {/* Title */}
          <header className="mb-6 text-center">
            <h1 className="text-4xl md:text-5xl font-semibold text-[#2B387D] font-amiri">Scoreboard</h1>
          </header>

          <div className="mb-10 flex w-full items-center justify-center">
            <div className="flex max-w-full gap-3 overflow-x-auto px-2 py-1">
              {dates.map((d) => (
                <DatePill key={d} iso={d} selected={d === selected} onSelect={setSelected} />
              ))}
            </div>
          </div>

          <h2 className="mb-6 text-center font-semibold font-amiri text-3xl md:text-4xl text-[#2B387D]">Match Badminton Ganda Putra SMA</h2>
        </div>

        <section
          className="relative w-full min-h-[240px]"
          style={{
            backgroundImage: `url('${backgroundImageUrl}')`,
            backgroundSize: "cover",
            backgroundPosition: "center",
          }}
        >
          <div className="absolute inset-0   bg-[#00152aaf]" />
          <div className="relative mx-auto max-w-6xl px-4 py-16">
            <div className="flex flex-col gap-8">
              {dayMatches.length === 0 ? (
                <div className="mx-auto w-full max-w-3xl border border-dashed border-slate-300 bg-white/80 p-10 text-center text-slate-700">
                  Belum ada pertandingan untuk tanggal ini.
                </div>
              ) : (
                dayMatches.map((m, i) => <MatchCard key={i} match={m} />)
              )}
            </div>
          </div>
        </section>
      </div>

      <Footer />
    </div>
  );
}

